<template>
  <div>
    <vue-tags-input
      v-model="tag"
      :tags="tags"
      :autocomplete-items="filteredItems"
      placeholder="Enter a keyword"
      @tags-changed="tagsChanged"
    >
    </vue-tags-input>
  </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  name: "autocompleteWrapper",
  components: {
    VueTagsInput,
  },
  props: {
    autocompleteItems: {
      type: Array,
      default: [],
    },
    propTags: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      tag: "",
      tags: [],
    };
  },
  updated: function () {
    this.tags = this.propTags;
  },
  computed: {
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    },
  },
  methods: {
    tagsChanged(newTags) {
      this.tags = newTags;
      this.$emit("keywords-changed", this.tags);
    },
  },
};
</script>

<style lang="scss">
@import "../styles/variables";

.ti-new-tag-input {
  font-size: 0.85rem;
  font-family: $font-family;
}
#resourceApp .vue-tags-input {
  .ti-tag {
    display: none;
  }
  .ti-selected-item {
    background: $gray--medium;
    color: $black;
    font-weight: $bold-weight;
  }
}
</style>
